import { z } from 'zod'
import { api } from './client'
import { chatMessageViewSchema, chatThreadViewSchema } from './schemas'

export type ChatThreadView = z.infer<typeof chatThreadViewSchema>
export type ChatMessageView = z.infer<typeof chatMessageViewSchema>

export interface SendMessageRequest {
  threadId?: string
  peerId?: string
  studentId?: string
  text: string
}

const chatPeerSchema = z.object({
  id: z.string(),
  name: z.string(),
  role: z.string(),
})
export type ChatPeer = z.infer<typeof chatPeerSchema>

const openThreadResponseSchema = z.object({ threadId: z.string() })

async function parsed<T>(p: Promise<unknown>, schema: { parse: (raw: unknown) => T }): Promise<T> {
  const raw = await p
  return schema.parse(raw)
}

export const chatApi = {
  peersForStudent: (studentId: string): Promise<ChatPeer[]> =>
    parsed(api(`/chat/peers/${studentId}`), z.array(chatPeerSchema)),

  listThreads: (): Promise<ChatThreadView[]> =>
    parsed(api('/chat/threads'), z.array(chatThreadViewSchema)),

  listMessages: (threadId: string): Promise<ChatMessageView[]> =>
    parsed(api(`/chat/threads/${threadId}/messages`), z.array(chatMessageViewSchema)),

  openThread: (peerId: string, studentId: string) =>
    parsed(
      api('/chat/threads/open', {
        method: 'POST',
        body: JSON.stringify({ peerId, studentId }),
      }),
      openThreadResponseSchema,
    ),

  sendMessage: (body: SendMessageRequest): Promise<ChatMessageView> =>
    parsed(
      api('/chat/messages', { method: 'POST', body: JSON.stringify(body) }),
      chatMessageViewSchema,
    ),
}
